var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcLink32(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3531_6626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 2.66669L13.4603 4.07341L6.53968 7.92663L4 9.33335V22.6667L6.53968 24.0734L13.5238 27.9266L16.0635 29.3334L18.6032 27.9266L25.4603 24.0734L28 22.6667V9.33335L25.4603 7.92663L18.5397 4.07341L16 2.66669ZM9.07937 19.8532V12.1468L16 8.2936L22.9206 12.1468V19.8532L16 23.7064L9.07937 19.8532Z",
    fill: "#2A5ADA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3531_6626"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 26.6667,
    fill: "white",
    transform: "translate(4 2.66669)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLink32);
export default __webpack_public_path__ + "static/media/ic_link_32.e7f1b257ff85baafdd6fccee225e9d5e.svg";
export { ForwardRef as ReactComponent };